/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { AuthErrorDtoModel, AuthErrorDtoModelType } from "./AuthErrorDtoModel"
import { AuthErrorDtoModelSelector } from "./AuthErrorDtoModel.base"
import { UserDtoModel, UserDtoModelType } from "./UserDtoModel"
import { UserDtoModelSelector } from "./UserDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  user: UserDtoModelType;
}

/**
 * AuthDtoBase
 * auto generated base class for the model AuthDtoModel.
 */
export const AuthDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('AuthDto')
  .props({
    __typename: types.optional(types.literal("AuthDto"), "AuthDto"),
    error: types.union(types.undefined, types.null, types.late((): any => AuthErrorDtoModel)),
    accessToken: types.union(types.undefined, types.null, types.string),
    user: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => UserDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class AuthDtoModelSelector extends QueryBuilder {
  get accessToken() { return this.__attr(`accessToken`) }
  error(builder: string | AuthErrorDtoModelSelector | ((selector: AuthErrorDtoModelSelector) => AuthErrorDtoModelSelector) | undefined) { return this.__child(`error`, AuthErrorDtoModelSelector, builder) }
  user(builder: string | UserDtoModelSelector | ((selector: UserDtoModelSelector) => UserDtoModelSelector) | undefined) { return this.__child(`user`, UserDtoModelSelector, builder) }
}
export function selectFromAuthDto() {
  return new AuthDtoModelSelector()
}

export const authDtoModelPrimitives = selectFromAuthDto().accessToken
